import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Menu } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { CARD_LOCALE_KEY } from '../InvoiceMetricsSection.utils';
export const SUGGEST_WIDGET_URL = 'https://forms.gle/anchor-suggest-metric-widget';
const BILLING_HEALTH_CARDS = [
    'collection-rate',
    'anchor-vs-external',
    'avg-days-to-pay',
    'avg-invoice',
    'outstanding',
    'aging-breakdown'
];
const STATUS_CARDS = [
    'pending',
    'issued',
    'processing',
    'paid',
    'overdue',
    'voided',
    'refunded'
];
export const GetAddWidgetMenuTID = (parentTestId)=>getTestIds(parentTestId);
export const AddWidgetMenu = (param)=>{
    let { visibleCardIds, onAddCard, testId } = param;
    const { AddWidgetMenuTestIds } = useMemo(()=>GetAddWidgetMenuTID(testId), [
        testId
    ]);
    const { t: texts } = useLocaleKeys('components.invoiceMetricsSection');
    const visibleSet = useMemo(()=>new Set(visibleCardIds), [
        visibleCardIds
    ]);
    const cardTitle = (id)=>texts.cards[CARD_LOCALE_KEY[id]].title();
    const cardDescription = (id)=>texts.addWidgetMenu.cardDescriptions[CARD_LOCALE_KEY[id]]();
    const buildGroup = (groupId, label, availableCardIds)=>{
        if (availableCardIds.length === 0) return [];
        return [
            {
                id: groupId,
                isSectionHeader: true,
                label
            },
            ...availableCardIds.map((cardId)=>({
                    id: cardId,
                    title: cardTitle(cardId),
                    body: cardDescription(cardId),
                    bi: {
                        name: 'invoice_metrics_add_widget',
                        data: {
                            card_id: cardId
                        }
                    },
                    onClick: ()=>onAddCard(cardId)
                }))
        ];
    };
    const items = [
        ...buildGroup('group-billingHealth', texts.addWidgetMenu.billingHealthGroup(), BILLING_HEALTH_CARDS.filter((id)=>!visibleSet.has(id))),
        ...buildGroup('group-status', texts.addWidgetMenu.statusGroup(), STATUS_CARDS.filter((id)=>!visibleSet.has(id)))
    ];
    return /*#__PURE__*/ _jsx(Menu, {
        testId: AddWidgetMenuTestIds.Root(),
        items: items,
        emptyText: texts.addWidgetMenu.emptyState(),
        dimensions: {
            width: 360,
            maxHeight: 420
        },
        footer: {
            items: [
                {
                    variant: 'promotionalAction',
                    props: {
                        title: texts.addWidgetMenu.suggestWidget.title(),
                        body: texts.addWidgetMenu.suggestWidget.subtitle(),
                        onClick: ()=>window.open(SUGGEST_WIDGET_URL, '_blank', 'noopener,noreferrer'),
                        bi: {
                            name: 'invoice_metrics_suggest_widget'
                        }
                    }
                }
            ]
        }
    });
};
